module.exports = __webpack_public_path__ + "img/l.b092fbbc.jpg";